<div class="page">
  <!-- INICIO ENCABEZADO -->
  <div class="header">
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Registro de signos vitales</h1>
      <p>Completa la información</p>
    </div>

    <button
      mat-flat-button
      class="add-boton add-boton--derecha add-boton--grande"
      (click)="abrirGragicaSignosVitales()"
    >
      Historial de signos vitales <mat-icon>monitor_heart</mat-icon>
    </button>
  </div>
  <!-- FIN ENCABEZADO -->

  <!-- INCIO DATOS DE PACIENTE -->
  <div class="datos">
    <!-- Información del paciente -->
    <div class="dato-item">
      <div class="icon-box">
        <mat-icon>person</mat-icon>
      </div>

      <div class="info">
        <h1>
          {{ paciente.nombre }}
          {{ paciente.apellido }}
          {{ paciente.segundoApellido }}
        </h1>

        @if (paciente.genero === 'masculino') {
          <p>Género: Masculino</p>
        }
        @if (paciente.genero === 'femenino') {
          <p>Género: Femenino</p>
        }
        <p>Edad: {{ obtenerEdad() }} ({{ paciente.fechaNacimiento | date: 'dd/MM/yyyy' }})</p>

        <p>ID: {{ paciente.id }}</p>
        <p>Tel: {{ paciente.telefono }}</p>
      </div>
    </div>

    <!-- Tipo de sangre -->
    <div class="dato-item">
      <div class="icon-box">
        <mat-icon>bloodtype</mat-icon>
      </div>

      <div class="info">
        <p>Tipo de sangre</p>

        <h1>
          {{ paciente.tipoSangre }}
        </h1>
      </div>
    </div>

    <!-- Fecha de registro -->
    <div class="dato-item">
      <div class="info">
        <p>Fecha de registro</p>

        <h1>
          {{ fechaActual | date: 'dd/MM/yyyy' }}
        </h1>
      </div>
    </div>
  </div>
  <!-- FIN DATOS DE PACIENTE  -->

  <!-- INICIO SIGNOS VITALES  -->
  <form [formGroup]="firstFormGroup" class="formulario">
    <!-- Peso -->
    <mat-form-field appearance="outline">
      <mat-label>Peso</mat-label>

      <input
        matInput
        type="number"
        placeholder="0.0"
        formControlName="peso"
        min="0.5"
        max="300"
        step="0.1"
      />

      <span matSuffix class="unidad">Kg</span>

      <mat-hint>Rango permitido: 0.5 – 300 kg</mat-hint>
    </mat-form-field>

    <!-- Talla -->
    <mat-form-field appearance="outline">
      <mat-label>Talla</mat-label>

      <input
        matInput
        type="number"
        placeholder="0.0"
        formControlName="estatura"
        min="40"
        max="250"
        step="0.1"
      />

      <span matSuffix class="unidad">cm</span>

      <mat-hint>Rango permitido: 40 – 250 cm</mat-hint>
    </mat-form-field>

    <!-- Saturación de oxígeno -->
    <mat-form-field appearance="outline">
      <mat-label>Saturación de oxígeno</mat-label>

      <input
        matInput
        type="number"
        placeholder="0"
        formControlName="saturacionOxigeno"
        min="50"
        max="100"
        step="1"
      />

      <span matSuffix class="unidad">%</span>

      <mat-hint>Rango permitido: 50 – 100 %</mat-hint>
    </mat-form-field>

    <!-- Saturación de oxígeno -->
    @if (frecuenciaRespiratoriaDisponible) {
      <mat-form-field appearance="outline">
        <mat-label>Frecuencia respiratoria</mat-label>

        <input
          matInput
          type="number"
          placeholder="0"
          formControlName="frecuenciaRespiratoria"
          min="10"
          max="100"
          step="1"
        />

        <span matSuffix class="unidad">RPM</span>

        <mat-hint>Rango permitido: 10 – 100 RPM</mat-hint>
      </mat-form-field>
    }

    <!-- Frecuencia cardíaca -->
    <mat-form-field appearance="outline">
      <mat-label>Frecuencia cardíaca</mat-label>

      <input
        matInput
        type="number"
        placeholder="0"
        formControlName="frecuenciaCardiaca"
        min="40"
        max="300"
        step="1"
      />

      <span matSuffix class="unidad">lpm</span>

      <mat-hint>Rango permitido: 40 – 300 lpm</mat-hint>
    </mat-form-field>

    <!-- Glucosa -->
    <mat-form-field appearance="outline">
      <mat-label>Glucosa</mat-label>

      <input
        matInput
        type="number"
        placeholder="0"
        formControlName="glucosa"
        min="20"
        max="600"
        step="1"
      />

      <span matSuffix class="unidad">mg/dL</span>

      <mat-hint>Rango permitido: 20 – 600 mg/dL</mat-hint>
    </mat-form-field>

    <!-- Temperatura -->
    <mat-form-field appearance="outline">
      <mat-label>Temperatura</mat-label>

      <input
        matInput
        type="number"
        placeholder="0.0"
        formControlName="temperatura"
        min="25"
        max="45"
        step="0.1"
      />

      <span matSuffix class="unidad">°C</span>

      <mat-hint>Rango permitido: 25 – 45 °C</mat-hint>
    </mat-form-field>

    <!-- Presión arterial -->
    <div class="presion-arterial">
      <!-- Sistólica -->
      <mat-form-field appearance="outline">
        <mat-label>Sistólica</mat-label>

        <input
          matInput
          type="number"
          placeholder="120"
          formControlName="presionSistolica"
          min="50"
          max="250"
          step="1"
        />

        <span matSuffix class="unidad">mmHg</span>

        <mat-hint>{{ esMenorDe16 ? 'Opcional (menor de 16 años)' : '50 – 250 mmHg' }}</mat-hint>
      </mat-form-field>

      <span class="separador-presion">/</span>

      <!-- Diastólica -->
      <mat-form-field appearance="outline">
        <mat-label>Diastólica</mat-label>

        <input
          matInput
          type="number"
          placeholder="80"
          formControlName="presionDiastolica"
          min="20"
          max="150"
          step="1"
        />

        <span matSuffix class="unidad">mmHg</span>

        <mat-hint>{{ esMenorDe16 ? 'Opcional (menor de 16 años)' : '20 – 150 mmHg' }}</mat-hint>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Prioridad</mat-label>

      <mat-select formControlName="prioridad">
        <mat-option value="Emergencia">
          <span class="prioridad-option">
            <span class="semaforo rojo"></span>
            Emergencia
          </span>
        </mat-option>

        <mat-option value="UrgenteMayor">
          <span class="prioridad-option">
            <span class="semaforo naranja"></span>
            Urgencia mayor
          </span>
        </mat-option>

        <mat-option value="Urgente">
          <span class="prioridad-option">
            <span class="semaforo amarillo"></span>
            Urgencia
          </span>
        </mat-option>

        <mat-option value="UrgenciaMenor">
          <span class="prioridad-option">
            <span class="semaforo verde"></span>
            Urgencia menor
          </span>
        </mat-option>

        <mat-option value="SinUrgencia">
          <span class="prioridad-option">
            <span class="semaforo azul"></span>
            Sin urgencia
          </span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="observaciones">
      <mat-label>Observaciones</mat-label>

      <textarea
        matInput
        rows="3"
        placeholder="Escribe aquí las observaciones del paciente..."
        formControlName="observaciones"
      >
      </textarea>
    </mat-form-field>
  </form>

  <div class="btnGuardar">
    <button mat-flat-button class="add-boton" (click)="guardarSignosVitales(true)">
      Enviar a sala de espera <mat-icon>list_alt_add</mat-icon>
    </button>
    <button mat-flat-button class="add-boton" (click)="guardarSignosVitales(false)">
      Guardar información <mat-icon>save</mat-icon>
    </button>
  </div>

  <!-- FIN SIGNOS VITALES -->
</div>
